(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.txt_timeframe = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#1E2944").s().p("AhgBwQgpgsAAhDIAAgBQAAhAAqguQArgwBDAAQA/AAAxAoIgPARQgqglg5AAQg2AAgkApQgkAoAAA5IAAAAQAAA9AjAmQAkAoA8AAQA5AAApgjIAAhZIhnAAIAAgUIB9AAIAAB2Qg0AuhFAAQhGAAgrgvg");
	this.shape.setTransform(615.5,21.825);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#1E2944").s().p("ABvCaIjZkRIAAERIgVAAIAAkzIAVAAIDUELIAAkLIAWAAIAAEzg");
	this.shape_1.setTransform(577.15,21.8);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#1E2944").s().p("AgKCaIAAkzIAVAAIAAEzg");
	this.shape_2.setTransform(549.75,21.8);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#1E2944").s().p("ABvCaIjYkRIAAERIgWAAIAAkzIAVAAIDUELIAAkLIAWAAIAAEzg");
	this.shape_3.setTransform(522.35,21.8);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#1E2944").s().p("ABuCaIjYkRIAAERIgVAAIAAkzIAVAAIDUELIAAkLIAWAAIAAEzg");
	this.shape_4.setTransform(483.6,21.8);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#1E2944").s().p("AgLCaIAAkzIAXAAIAAEzg");
	this.shape_5.setTransform(456.2,21.8);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#1E2944").s().p("ABaCcIhakLIhZELIgSAAIhxk2IAaAAIBhESIBakTIARAAIBaETIBhkSIAXAAIhvE2g");
	this.shape_6.setTransform(421.95,21.85);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#1E2944").s().p("AiECaIAAkzIBmAAQBHAAAuAsQAuArAABCIAAAAQAABCguAsQguAshHAAgAhuCFIBQAAQA+AAAngnQAmgkAAg5IAAgBQAAg3gmgmQgngng+AAIhQAAg");
	this.shape_7.setTransform(360,21.8);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#1E2944").s().p("ABgCaIhhh/IhlAAIAAB/IgWAAIAAkzICAAAQA4AAAfAeQAXAYAAAhIAAABQAAAlgaAYQgYAVgoAFIBlCEgAhmAGIBnAAQAoAAAZgSQAZgTAAggIAAgCQAAgegXgTQgYgSgpAAIhpAAg");
	this.shape_8.setTransform(323.425,21.8);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#1E2944").s().p("ACBCbIgnhWIi1AAIgnBWIgYAAICQk1IAVAAICQE1gABRAwIhRixIhRCxICiAAg");
	this.shape_9.setTransform(284.95,21.7);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#1E2944").s().p("ABaCcIhakLIhZELIgSAAIhxk2IAaAAIBhESIBakTIARAAIBaETIBhkSIAXAAIhvE2g");
	this.shape_10.setTransform(243.3,21.85);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#1E2944").s().p("ACBCbIgnhWIi0AAIgoBWIgXAAICPk1IAVAAICPE1gABQAwIhQixIhRCxIChAAg");
	this.shape_11.setTransform(201.65,21.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.txt_timeframe, new cjs.Rectangle(0,0,821.2,48), null);


(lib.txt_smarter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("Ai8D+IAAgQQAcgJAJgYQAFgSABgxIAAkNQAAgdgLgNQgLgQgggLIAAgRICpgkIAAB1QA2hcBRgVQAtgKAeAbQAUAVAAAdQAAAcgUAVQgUAUgdABQgdAAgVgUQgVgWACgaQADgQgjAVQgjAVgZAtIAAD3QAAAxAIATQAJAZAaAHIAAAQg");
	this.shape.setTransform(336.1,19.95);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AilC2QhChLAAhoQAAhzBFhJQBEhJBqAAQDcAAAAD5IlWAAQAJCtCFAVQAwAHAzgUQAzgVASgmIAPAHQgOAzguAnQg+AxhbAAQhjAAhEhNgAB4gZQAAhngjg9Qggg1guAAQguAAgkBAQgjBAAABZIDmAAIAAAAg");
	this.shape_1.setTransform(288.9,20.425);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AhJExQgjgnAAhdIAAlGIg2AAIgDgRIA5AAIAAiVIBygSIAACnICAAAIgEARIh8AAIAAFDQAABnBRAAQAuAAATgpIAOAIQgPAngmAcQgrAfgwAAQhAAAgfghg");
	this.shape_2.setTransform(246.075,12.55);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ai9D+IAAgQQAdgJAJgYQAFgSAAgxIAAkNQAAgdgKgNQgLgQgggLIAAgRICpgkIAAB1QA3hcBQgVQAtgKAeAbQAUAVAAAdQAAAcgUAVQgVAUgcABQgdAAgWgUQgTgWABgaQADgQgjAVQgkAVgYAtIAAD3QAAAxAIATQAJAZAaAHIAAAQg");
	this.shape_3.setTransform(208.35,19.95);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AAgCqQgLAmgqAZQgsAag4AAQh8AAAAhtQAAhOBFgkQApgWCmgqIAAhBQAAhUgmgmQgogmg8AdQgZAMgKAPQgIAMAGABQAYADANASQAOATgEAWQgEAXgSAOQgTANgYgEQgWgDgNgTQgWgeARgdQAbgwA6ggQAvgYA3ADQBaAAAoA9QAhAzAABoIAACsQAABHAzAAQAYAAAGgWIARAGQgHAcgeAWQghAYgsAAIgCAAQhXAAgLhZgAh/B8QAAAXANAWQAVAhAsAAQA6AAAWg7IAAiZQieAjAABjg");
	this.shape_4.setTransform(162.975,20.4092);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("ADJD+IAAgQQAcgIAJgZQAGgSAAgwIAAjdQAAhqhZAAQgiAAgfAgQgdAdAAAhIAAANIABDcQABAwAHAUQAKAYAbAHIAAAQIjJAAIAAgQQAdgIAIgZQAHgSgBgwIAAjdQAAhqhXAAQgiAAgeAgQgcAdgDAeIAADtQAAAwAIATQAJAYAbAHIAAAQIjJAAIAAgQQAcgIAJgYQAFgRAAgxIAAkKQABgegLgOQgMgRgggNIAAgRICpgkIAABvQAUgwArgfQAuggAyAAQBygBAVB1QAQgyAughQAtghA0AAQBEAAAiAjQAlAogBBeIAADfQAAAwAJAUQAJAYAbAHIAAAQg");
	this.shape_5.setTransform(93.3,19.95);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AivDVIAAiNIAQAAQAkCrCLAAQBGAAADg7QADg7g/gpIhshCQifhlBQh1QAlg6BtAAQB7AAA1AiIAAB+IgQAAQgeiQiCAAQhDAAgGA1QgHA3BEAsIBsBEQBKAsAUA+QAVA/gnA4QgnA4hpAAQiBAAg+gug");
	this.shape_6.setTransform(29.6756,20.425);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.txt_smarter, new cjs.Rectangle(5,-36,388,112), null);


(lib.txt_skincare = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AilC2QhChLAAhoQAAhzBFhJQBEhJBqAAQDcAAAAD5IlWAAQAJCtCFAVQAwAHAzgUQAzgVASgmIAPAHQgOAzguAnQg+AxhbAAQhjAAhEhNgAB4gZQAAhngjg9Qggg1guAAQguAAgkBAQgjBAAABZIDmAAIAAAAg");
	this.shape.setTransform(344.25,20.425);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("Ai9D+IAAgQQAdgJAIgYQAHgSgBgxIAAkNQAAgdgKgNQgLgQgggLIAAgRICpgkIAAB1QA2hcBRgVQAtgKAeAbQAUAVAAAdQAAAcgUAVQgVAUgcABQgdAAgWgUQgTgWABgaQADgQgjAVQgkAVgYAtIAAD3QAAAxAIATQAJAZAbAHIAAAQg");
	this.shape_1.setTransform(300.85,19.95);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AAgCqQgLAmgqAZQgsAag4AAQh8AAAAhtQAAhOBFgkQApgWCmgqIAAhBQAAhUgmgmQgogmg8AdQgZAMgKAPQgIAMAGABQAYADANASQAOATgEAWQgEAXgSAOQgTANgYgEQgWgDgNgTQgWgeARgdQAbgwA6ggQAvgYA3ADQBaAAAoA9QAhAzAABoIAACsQAABHAzAAQAYAAAGgWIARAGQgHAcgeAWQghAYgsAAIgCAAQhXAAgLhZgAh/B8QAAAXANAWQAVAhAsAAQA6AAAWg7IAAiZQieAjAABjg");
	this.shape_2.setTransform(255.475,20.4092);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AiYC3QhFhNAAhqQAAhnBGhJQBNhSB7AAQBgAAAxA4QAaAggPAfQgJAXgXAKQgYALgXgJQgXgIgKgXQgKgXAJgXQAJgZAXgJQAKgDgXgMQgYgMgmAAQgxAAgpApQg+A8AAB+QABBaAtA0QAmAtA/AKQAvAHA0gYQAwgWASgfIANAHQgOA0gtAnQg6AxhaAAQhiAAhFhMg");
	this.shape_3.setTransform(205.5,20.425);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AA+D+IAAgQQAdgIAIgZQAGgSAAgwIAAjdQAAgvgagdQgbgdgugBQgjAAgfAfQgfAcgDAgIAADtQAAAwAHATQAKAYAbAHIAAAQIjJAAIAAgQQAcgIAIgYQAGgRAAgxIAAkPQAAgdgKgNQgLgOghgNIAAgRICpgkIAAByQARgvA0giQAyghA1AAQCOgBAACqIAADfQAAAwAHAUQAKAYAbAHIAAAQg");
	this.shape_4.setTransform(155.875,19.95);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AheFrIAAgRQAdgJAIgYQAHgSAAgwIAAkNQAAgcgLgOQgLgOghgOIAAgQICnglIAAGIQABAxAGATQAKAYAbAHIAAARgAgyj8QgSgTAAgaQAAgbASgTQATgTAbAAQAZAAATATQAUATAAAbQAAAagUATQgTASgZAAQgbAAgTgSg");
	this.shape_5.setTransform(115.65,9.125);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("ACUGRQg2AAgcgXQgWgTg7hWQgZgjgvg+IBlhsQCeiYiPADIAAgQID9AAIAAAQQh1AEijC8QB4CpA2A4QAiAtA+ADIAAARgAkOGRIAAgRQAcgIAJgZQAGgSAAgwIAAo4QAAgdgKgNQgMgPgggJIAAgQICpgjIAAKtQAAAxAHATQAJAZAcAGIAAARg");
	this.shape_6.setTransform(75.425,5.325);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("AivDVIAAiNIAQAAQAkCrCLAAQBGAAADg7QADg7g/gpIhshCQifhlBQh1QAlg6BtAAQB7AAA1AiIAAB+IgQAAQgeiQiCAAQhDAAgGA1QgHA3BEAsIBsBEQBKAsAUA+QAVA/gnA4QgnA4hpAAQiBAAg+gug");
	this.shape_7.setTransform(25.8756,20.425);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.txt_skincare, new cjs.Rectangle(-14,-36,401.1,112), null);


(lib.txt_simply = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AiwF1QgZgLgKgaQgKgZALgaQAMgYAZgKQAagLAZAMQAYALAIAcQAEAMAOgLQAQgLAMgeIAsh8QhijahojfQgUgtg1gDIAAgQIDvAAIAAAQQg/AAAhBIIB7EKIBAirQBFiph8ACIAAgQIDSAAIAAAQQggAAgZAXQgnAmgrBtIimG9QgcBLguAjQgOALgVAEIgMABQgOAAgMgGg");
	this.shape.setTransform(268.75,33.3659);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AhfGRIAAgRQAdgIAIgZQAHgSAAgwIAAo4QAAgdgLgNQgMgPgfgJIAAgQICngjIAAKtQAAAxAHATQAKAZAcAGIAAARg");
	this.shape_1.setTransform(231.05,5.325);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AkMGOIAAgRQAdgIAIgWQAGgQAAgvIAAo8QAAgcgKgLQgKgLghgJIAAgRICoglIAABWQAXgqAzgYQAqgUAtAAQBkAABABJQBABIAAB3QAAB7hKBDQhFBAh0AAQhMAAg2glIAADMQAAAwAIARQAIAVAcAHIAAARgAhLlFQgeAhgFA1IAADIQAFBIAnAmQAiAiAyAAQCAAAAAjhQAAjwiNAAQgwAAggAjg");
	this.shape_2.setTransform(193.075,34.275);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("ADJD+IAAgQQAcgIAJgZQAGgSAAgwIAAjdQAAhqhYAAQgjAAgeAgQgeAdAAAhIAAANIABDcQAAAwAIAUQAJAYAcAHIAAAQIjJAAIAAgQQAdgIAIgZQAGgSABgwIAAjdQAAhqhZAAQghAAgeAgQgcAdgDAeIAADtQAAAwAHATQAKAYAbAHIAAAQIjJAAIAAgQQAcgIAIgYQAHgRAAgxIAAkKQAAgegLgOQgLgRghgNIAAgRICpgkIAABvQAUgwAsgfQAsggAyAAQB0gBATB1QARgyAughQAtghA0AAQBFAAAgAjQAlAoAABeIAADfQABAwAHAUQAKAYAbAHIAAAQg");
	this.shape_3.setTransform(123.75,19.95);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AhdFrIAAgRQAcgJAJgYQAGgSAAgwIAAkNQAAgcgLgOQgLgOgigOIAAgQICoglIAAGIQAAAxAHATQAKAYAbAHIAAARgAgyj8QgSgTAAgaQAAgbASgTQASgTAcAAQAZAAAUATQATATAAAbQAAAagTATQgUASgZAAQgcAAgSgSg");
	this.shape_4.setTransform(68.65,9.125);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FFFFFF").s().p("AivDVIAAiNIAQAAQAkCrCLAAQBGAAADg7QADg7g/gpIhshCQifhlBQh1QAlg6BtAAQB7AAA1AiIAAB+IgQAAQgeiQiCAAQhDAAgGA1QgHA3BEAsIBsBEQBKAsAUA+QAVA/gnA4QgnA4hpAAQiBAAg+gug");
	this.shape_5.setTransform(32.7256,20.425);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.txt_simply, new cjs.Rectangle(-2,-36,311.1,112), null);


(lib.hitArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AnyCXQhkgBAAhjIAAhlQAAhkBkAAIPkAAQBlAAgBBkIAABlQABBjhlABg");
	this.shape.setTransform(60.9971,22.4747,1.0195,1.4937);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,122,45);


(lib.button_shimmer_svg = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["rgba(255,255,255,0)","rgba(0,0,102,0.898)","#000066","rgba(0,0,102,0.898)","rgba(255,255,255,0)"],[0,0.451,0.498,0.549,1],-10,0,10,0).s().p("AhjKKIAA0TIDHAAIAAUTg");
	this.shape.setTransform(10,65);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.button_shimmer_svg, new cjs.Rectangle(0,0,20,130), null);


(lib.btn_visuals = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#1E2944").s().p("AAZAvIgZhIIgYBIIgMAAIghhdIAPAAIAYBKIAZhKIALAAIAZBKIAZhKIAOAAIghBdg");
	this.shape.setTransform(38.45,2.95);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#1E2944").s().p("AgiAiQgNgNAAgVIAAAAQAAgTANgOQAOgOAUAAQAVgBAOAOQANAOAAAUIAAAAQAAAUgNAOQgOAPgVAAQgUAAgOgPgAgYgZQgJAKAAAPIAAAAQAAAPAKAKQAJALAOAAQAPAAAKgLQAJgKAAgPIAAAAQAAgOgKgLQgKgKgOgBQgOABgKAKg");
	this.shape_1.setTransform(25.375,2.95);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#1E2944").s().p("AAqA/IhRhnIAABnIgNAAIAAh9IANAAIBOBkIAAhkIAOAAIAAB9g");
	this.shape_2.setTransform(12.475,1.3);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#1E2944").s().p("AguA+IAAh5IAOAAIAAATQAOgVAVAAQARAAANANQAOAOAAAVIAAABQAAAUgOAOQgNANgRAAQgWAAgNgUIAAAvgAgXgmQgKAKABAPIAAABQgBAOAKALQALAJAMABQAOAAAJgKQAJgKAAgPIAAAAQAAgQgJgLQgKgJgNAAQgMgBgLALg");
	this.shape_3.setTransform(-5.75,4.3);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#1E2944").s().p("AgiAiQgNgNAAgVIAAAAQAAgTANgOQAOgOAUAAQAVgBAOAOQANAOAAAUIAAAAQAAAUgNAOQgOAPgVAAQgUAAgOgPgAgYgZQgJAKAAAPIAAAAQAAAPAKAKQAJALAOAAQAPAAAKgLQAJgKAAgPIAAAAQAAgOgKgLQgKgKgOgBQgOABgKAKg");
	this.shape_4.setTransform(-17.775,2.95);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#1E2944").s().p("AAbBCIAAg3QAAgMgHgHQgHgIgMAAQgLAAgIAIQgIAIAAAMIAAA2IgOAAIAAiDIAOAAIAAA3QALgSAUAAQARAAAJAKQAKAKAAAQIAAA6g");
	this.shape_5.setTransform(-29.025,1.025);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#1E2944").s().p("AguAtIAJgLQATASAXAAQAMAAAIgGQAIgGAAgKIAAAAQAAgJgHgFQgHgFgTgEQgVgGgKgHQgKgIAAgPIAAAAQAAgQAMgJQALgKASAAQAYAAAUAPIgJAMQgRgOgSAAQgMAAgIAGQgHAGAAAIQAAAKAHAFQAHAGATAEQAWAFAJAHQAKAJAAAOQAAAQgMAKQgMAKgTAAQgcAAgWgUg");
	this.shape_6.setTransform(-40.475,1.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// button
	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FFFFFF").s().p("An9DhQhkAAAAhkIAAj5QAAhkBkAAIP7AAQBkAAAABkIAAD5QAABkhkAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape_7).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.btn_visuals, new cjs.Rectangle(-61,-22.5,122,45), null);


(lib.shineDiagonal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button_shimmer_svg
	this.instance = new lib.button_shimmer_svg();
	this.instance.setTransform(-0.05,0,1,1,45,0,0,10,65);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-56.5,-56.5,113.1,113.1);


(lib.mc_shineSweep = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_15 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(15).call(this.frame_15).wait(1));

	// shine_mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AJBDhQhkAAAAhkIAAj5QAAhkBkAAIP8AAQBkAAAABkIAAD5QAABkhkAAg");
	mask.setTransform(169.675,2.9);

	// shine_anim
	this.instance = new lib.shineDiagonal("synched",0);
	this.instance.setTransform(199.05,0.9);
	this.instance.alpha = 0.1016;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({rotation:22.0005,x:369.8,y:7.6,alpha:0.0508},15).wait(1));

	// shine_anim_latent
	this.instance_1 = new lib.shineDiagonal("synched",0);
	this.instance_1.setTransform(199.05,0.9);
	this.instance_1.alpha = 0.0508;
	this.instance_1._off = true;

	var maskedShapeInstanceList = [this.instance_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(2).to({_off:false},0).to({rotation:22.0005,x:369.8,y:7.6,alpha:0.0195},13).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(217.4,-19.6,121.99999999999997,45);


(lib.btn_cta = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {over:8,out:22};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
		this.stop();
	}
	this.frame_14 = function() {
		this.stop();
	}
	this.frame_15 = function() {
		this.gotoAndPlay("over");
	}
	this.frame_29 = function() {
		this.stop();
	}
	this.frame_54 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(14).call(this.frame_14).wait(1).call(this.frame_15).wait(14).call(this.frame_29).wait(25).call(this.frame_54).wait(1));

	// hitArea
	this.hit = new lib.hitArea("synched",0);
	this.hit.name = "hit";
	this.hit.setTransform(-1.6,-7.5,1,1,0,0,0,60,15);

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(55));

	// shineSweep
	this.mc_shineSweep = new lib.mc_shineSweep();
	this.mc_shineSweep.name = "mc_shineSweep";
	this.mc_shineSweep.setTransform(-37.15,-0.5,1,1,0,0,0,240.2,0.9);

	this.timeline.addTween(cjs.Tween.get(this.mc_shineSweep).wait(55));

	// btn_visuals
	this.instance = new lib.btn_visuals();
	this.instance.setTransform(0,0,1.0167,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(8).to({scaleX:1},0).to({scaleX:1.05,scaleY:1.05},3).to({scaleX:1,scaleY:1},3).wait(41));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-131.3,-53.5,195.4,106.1);


// stage content:
(lib.neocutis1440x480left = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0];
	// timeline functions:
	this.frame_0 = function() {
		this.btn_cta.addEventListener("click", function () {
		  window.open(window.clickTag || "https://store.neocutis.com/collections/all", "_self");
		}.bind(this));
		stage.enableMouseOver();
		this.btn_cta.cursor = "pointer";
		
		// Set up hit area
		this.btn_cta.hitArea = this.btn_cta.hit;
		this.btn_cta.hit.visible = false;
		
		let btnIsHovered = false;
		
		this.btn_cta.addEventListener("mouseover", function () {
		  if (!btnIsHovered) {
		    btnIsHovered = true;
		    this.btn_cta.gotoAndPlay("over");
		    this.btn_cta.mc_shineSweep.gotoAndPlay(1);
		  }
		}.bind(this));
		
		this.btn_cta.addEventListener("mouseout", function () {
		  btnIsHovered = false;
		  this.btn_cta.gotoAndPlay("out");
		}.bind(this));
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(225));

	// button
	this.btn_cta = new lib.btn_cta();
	this.btn_cta.name = "btn_cta";
	this.btn_cta.setTransform(322.35,386.3,1.4898,1.4877,0,0,0,-60,-14.9);

	this.timeline.addTween(cjs.Tween.get(this.btn_cta).wait(225));

	// text_timeframe
	this.instance = new lib.txt_timeframe();
	this.instance.setTransform(412.4,81.85,1,1,0,0,0,412.4,31);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:129.85,alpha:1},6).wait(219));

	// headline_neo_word_in_3
	this.instance_1 = new lib.txt_skincare();
	this.instance_1.setTransform(636.05,310.15,1,1,0,0,0,411.9,62);
	this.instance_1.alpha = 0;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(19).to({_off:false},0).to({y:356.15,alpha:1},7).wait(199));

	// headline_neo_word_in_2
	this.instance_2 = new lib.txt_smarter();
	this.instance_2.setTransform(797.05,205.15,1,1,0,0,0,411.9,62);
	this.instance_2.alpha = 0;
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(12).to({_off:false},0).to({y:251.15,alpha:1},7).wait(206));

	// headline_neo_word_in_1
	this.instance_3 = new lib.txt_simply();
	this.instance_3.setTransform(480,205.15,1,1,0,0,0,411.9,62);
	this.instance_3.alpha = 0;
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(5).to({_off:false},0).to({y:251.15,alpha:1},7).wait(213));

	// color
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#30C0CD").ss(1,1,1).p("EhADglfMCAHAAAMAAABK/MiAHAAAg");
	this.shape.setTransform(410,240);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#30C0CD").s().p("EhADAlgMAAAhK/MCAHAAAMAAABK/g");
	this.shape_1.setTransform(410,240);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(225));

	// stageBackground
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1,3,true).p("EhBngnDMCDPAAAMAAABOHMiDPAAAg");
	this.shape_2.setTransform(410,240);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("EhBnAnEMAAAhOHMCDPAAAMAAABOHg");
	this.shape_3.setTransform(410,240);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2}]}).wait(225));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(409,239,1031,247.60000000000002);
// library properties:
lib.properties = {
	id: 'BF1AB29EBFDE460099CCABE88E1B5420_LEFT',
	width: 820,
	height: 480,
	fps: 15,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['BF1AB29EBFDE460099CCABE88E1B5420_LEFT'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;